export const Protoexpression = (fieldName: string, value, predicate: number) => {
    return {
        fieldName: fieldName,
        value: value,
        predicateId: predicate
    };
}

export const paginationExpression = (fieldName: string, value, predicate: number, entriesPerPage: number, pageNumber: number) => {
    let expression = {
        expressionRequest: {
            protoexpressions: [
                Protoexpression(fieldName, value, predicate)
            ]
        },
        paginationRequest: {
            entriesPerPage: entriesPerPage,
            pageNumber: pageNumber + 1
        }
    }
    return expression;
}
